import React from 'react';
import Navbar from './Navbar';

const Header = () => (
  <header className="header">
    <h2>Math Magicinians</h2>
    <Navbar />
  </header>
);

export default Header;
